@let attendeeRow = attendee();

<div
  class="new-reservation-dialog__attendee-row"
  [class.new-reservation-dialog__attendee-row--organizer]="attendeeRow.isOrganizer"
>
  <ng-template #attendeeAvailabilityReasonsTemplate>
    <div class="new-reservation-dialog__tooltip-content">
      @for (reason of attendeeRow.availabilityReasons; track reason) {
        <p>{{ reason }}</p>
      }
    </div>
  </ng-template>

  <div class="new-reservation-dialog__attendee-info">
    <div class="new-reservation-dialog__attendee-headline">
      <span
        class="new-reservation-dialog__availability-dot"
        [class.new-reservation-dialog__availability-dot--loading]="attendeeRow.availabilityState === 'loading'"
        [class.new-reservation-dialog__availability-dot--available]="attendeeRow.availabilityState === 'available'"
        [class.new-reservation-dialog__availability-dot--warning]="attendeeRow.availabilityState === 'warning'"
        [class.new-reservation-dialog__availability-dot--error]="attendeeRow.availabilityState === 'error'"
        [class.new-reservation-dialog__availability-dot--unknown]="attendeeRow.availabilityState === 'unknown'"
        [attr.aria-label]="attendeeRow.availabilityLabelKey | transloco"
        [cueTooltip]="attendeeRow.availabilityReasons.length > 0 ? attendeeAvailabilityReasonsTemplate : undefined"
        [cueTooltipCommonType]="'info'"
      ></span>
      <strong class="new-reservation-dialog__attendee-name">{{ attendeeRow.name }}</strong>
    </div>

    <div class="new-reservation-dialog__attendee-meta">
      <span class="new-reservation-dialog__attendee-initials">{{ attendeeRow.initials }}</span>
      <div class="new-reservation-dialog__attendee-meta-text">
        <span class="new-reservation-dialog__attendee-email">{{ attendeeRow.email }}</span>
        <span
          class="new-reservation-dialog__attendee-response"
          [class.new-reservation-dialog__attendee-response--accepted]="attendeeRow.responseStatus === 'accepted'"
          [class.new-reservation-dialog__attendee-response--rejected]="attendeeRow.responseStatus === 'rejected'"
          [class.new-reservation-dialog__attendee-response--none]="attendeeRow.responseStatus === 'none'"
          [class.new-reservation-dialog__attendee-response--tentative]="attendeeRow.responseStatus === 'tentative'"
        >
          {{ attendeeRow.responseStatusLabel }}
        </span>
      </div>
    </div>
  </div>

  @if (editable()) {
    <assist-dropdownlist
      class="new-reservation-dialog__attendee-participation"
      [data]="participationOptions()"
      [value]="attendeeRow.participation"
      textField="text"
      valueField="value"
      [valuePrimitive]="true"
      [popupSettings]="{ appendTo: 'component' }"
      (valueChange)="onParticipationChange($event)"
    />

    <cue-button
      type="delete"
      [icon]="icons.cueDelete"
      class="new-reservation-dialog__attendee-remove"
      btnClass="autowidth new-reservation-dialog__icon-cue-button"
      [title]="translation.newReservationUi.administration.removeAttendee | transloco"
      (click)="onRemoveAttendee($event)"
    />
  } @else {
    <span class="new-reservation-dialog__attendee-participation-label">
      {{ attendeeRow.participationLabel }}
    </span>
  }
</div>
